import React from 'react';
import { useWebinar } from '../../hooks/useWebinar';
const SHADES = ['bg-[#A5A1FF]', 'bg-[#4F46E5]', 'bg-[#7C75F7]', 'bg-white/40'];
export function WebinarProgram() {
  const c = useWebinar().copy.program;
  const programItems = c.items;
  const total = programItems.reduce((s, i) => s + i.minutes, 0);
  return <section id="programme" aria-labelledby="program-title" className="scroll-mt-[72px] bg-[#070A1C] border-t border-white/[0.06]" data-id="element-7944" data-mp="262v6k2cv5c53">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-12 lg:gap-20" data-id="element-7945" data-mp="2b0n0f1x2j8bx">
        <div data-id="element-7946" data-mp="2k1ul2h6nwanj">
          <h2 id="program-title" className="font-serif text-[2rem] md:text-[2.6rem] leading-[1.12] tracking-tight text-white" data-id="element-7947" data-mp="2k1bcvs6td0mp">{c.title}</h2>
          <p className="mt-6 max-w-[28rem] font-sans text-[15px] leading-relaxed text-[#A6ABC8]" data-id="element-7948" data-mp="2ozwenw1prsd9">{c.audience}</p>
        </div>

        <div data-id="element-7949" data-mp="ppwigy2uyd0m">
          {/* Proportional time bar */}
          <div className="flex h-2 gap-1 rounded-full overflow-hidden" aria-hidden="true" data-id="element-7950" data-mp="ung10a6l9byd">
            {programItems.map((item, i) => <span key={item.title} className={SHADES[i]} style={{
            width: `${item.minutes / total * 100}%`
          }} data-id="element-7951" data-mp="2d36zflcz709z" data-mpi={i} />)}
          </div>
          <ol className="mt-6 divide-y divide-white/[0.08] border-y border-white/[0.08]" data-id="element-7952" data-mp="23cko43cakvx3">
            {programItems.map((item, i) => <li key={item.title} className="grid grid-cols-[88px_1fr] md:grid-cols-[110px_1fr] items-baseline gap-4 py-6" data-id="element-7953" data-mp="1zbsakxwe04v0" data-mpi={i}>
                <span className="flex items-baseline gap-2" data-id="element-7954" data-mp="2r13u2c7vcwm0">
                  <span className={`w-2 h-2 rounded-full translate-y-[-3px] ${SHADES[i]}`} aria-hidden="true" data-id="element-7955" data-mp="2r1n6jder2ssn" />
                  <span className="font-serif text-[1.9rem] leading-none text-white" data-id="element-7956" data-mp="2n1mqjoc069jh">{item.minutes}</span>
                  <span className="font-sans text-[13px] text-[#8A90B2]" data-id="element-7957" data-mp="2i2jmo77re9d3">{c.min}</span>
                </span>
                <span className="font-sans text-[16px] md:text-[17px] leading-snug text-white/90" data-id="element-7958" data-mp="1bi0ja80fqcx7">{item.title}</span>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}